export default __webpack_public_path__ + "static/media/Multidisciplinary-Practice.9582f755.png";